module.exports = __webpack_public_path__ + "img/check.15434f67.png";